"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeMoneyAmount = exports.Adapter = void 0;
var money_helper_1 = require("./money.helper");
var money_currencies_1 = require("./money.currencies");
var Adapter = /** @class */ (function () {
    function Adapter() {
    }
    Adapter.normalizeDecimals = function (currency, decimals) {
        var value = Adapter.shouldConvertToNumber(decimals);
        return typeof value === 'number' ? value : Adapter.getDecimalUnit(currency);
    };
    Adapter.normalizeAmount = function (amount) {
        return Adapter.shouldConvertToNumber(amount);
    };
    Adapter.params = function (data) {
        var _a = Adapter.normalizeParams(data), unformattedAmount = _a[0], currency = _a[1], unformattedDecimals = _a[2];
        var amount = Adapter.normalizeAmount(unformattedAmount);
        var decimals = Adapter.normalizeDecimals(currency, unformattedDecimals);
        return [amount, currency, decimals];
    };
    Adapter.getDecimalUnit = function (currency, minorUnit) {
        if (Number.isInteger(minorUnit)) {
            return minorUnit;
        }
        try {
            return money_currencies_1.MONEY_CURRENCIES[currency].minorUnit;
        }
        catch (e) {
            return 2;
        }
    };
    Adapter.shouldConvertToNumber = function (value) {
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'string') {
            var converted = parseFloat(value);
            return Number.isNaN(converted) ? null : converted;
        }
        return null;
    };
    Adapter.stringToArray = function (data) {
        var _a = (0, money_helper_1.splitMoneyString)(data), amount = _a[0], currency = _a[1], decimals = _a[2];
        return [amount, currency, decimals];
    };
    Adapter.objectToArray = function (data) {
        return [data.amount, data.currency, data.decimals];
    };
    Adapter.normalizeParams = function (data) {
        return typeof data === 'string' ? Adapter.stringToArray(data) : Adapter.objectToArray(data);
    };
    return Adapter;
}());
exports.Adapter = Adapter;
function normalizeMoneyAmount(amount, currency, decimals) {
    var numberAmount = Adapter.shouldConvertToNumber(amount);
    var decimalUnit = Adapter.getDecimalUnit(currency, decimals);
    var value = numberAmount * Math.pow(10, decimalUnit);
    return Number.isInteger(value) ? value : Math.round(value);
}
exports.normalizeMoneyAmount = normalizeMoneyAmount;
